import ru from "./ru.json";
import en from "./en.json";

const i18nResources = { ru, en };

export default i18nResources;
